import { render } from "./FansRankingAllDataTabCont.vue?vue&type=template&id=6fa13bb4"
import script from "./FansRankingAllDataTabCont.vue?vue&type=script&lang=js"
export * from "./FansRankingAllDataTabCont.vue?vue&type=script&lang=js"

import "./FansRankingAllDataTabCont.vue?vue&type=style&index=0&id=6fa13bb4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__